import React from 'react';

export default class Page5 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt people">
                                    <div className="innerpadding">


                                        <div className="ilead-contentarea">

                                            <div className="border_subtitle">Self-awareness</div>
                                            <p>The effective influencer must be aware of his or her own skills
                                                and abilities and have a clear
                                                understanding of their preferred style of dealing with others.
                                                They should know their own
                                                strengths and weaknesses, motivators and de-motivators and
                                                sources of power and have a very
                                                clear understanding of their role in the influencing process.
                                                For example, if you know that you are
                                                good at making people feel at ease, be sure to use that strength
                                                at the start in order to get the
                                                best result.</p>
                                            <div className="border_subtitle">Awareness of others</div>
                                            <p>As well as being self-aware, an effective influencer will also be
                                                very aware of what makes others
                                                tick. Typically, they’ll observe others’ preferred influencing
                                                styles, the skills they use in influencing
                                                situations, their power bases and in particular what engages and
                                                disengages them. Awareness in
                                                this area will help you choose the right approach for whoever is
                                                involved, while also remaining
                                                open to being influenced by others. For example, if you know
                                                that someone you are trying to
                                                influence tends to be impatient, try to make your influencing
                                                style concise and to the point.</p>
                                            <div className="border_subtitle">Flexibility/adaptability</div>
                                            <p>The ability to change and adapt to suit the situation is vital.
                                                The skilled influencer realises that
                                                there is no right way of influencing. There are only effective
                                                skills which can help you in the
                                                process. The success of any influencing interaction is usually
                                                down to how the skills have been
                                                used in practice. Adaptability and flexibility are the keys.
                                                Flexibility to be able to vary your style
                                                and approach to suit the particular situation and people
                                                involved as well as the ability to assess
                                                the situation and people facing you. Make sure that when you are
                                                trying to influence you are
                                                doing things like keeping notice of body language, to see how
                                                receptive the individual is at that
                                                particular moment.</p>

                                            <div className="circle_title">
<span className="heading">
<img className="heading_image" src={require('@images/browndot.jpg')}/>
</span>
                                                <span className="heading">LEADING A FOOD REVOLUTION</span>
                                            </div>
                                            <p>This excerpt from Jamie Oliver’s Acceptance Speech at the TED
                                                Awards 2010 captures some of these key influencing
                                                strategies:</p>
                                            <p>TED (Technology, Entertainment and Design) is a global set of
                                                conferences formed to disseminate ‘ideas worth spreading’.</p>

                                            <div className="lightgreencontentbg keyquestionpad ">
                                                <p>‘Sadly, in the next 18 minutes when I do our chat, four
                                                    Americans that are alive will be dead from the food that
                                                    they eat.</p>
                                                <p>My name’s Jamie Oliver. I’m 34 years old. I’m from Essex in
                                                    England and for the last seven years I’ve worked fairly
                                                    tirelessly to save lives in my own way. I’m not a doctor;
                                                    I’m a chef, I don’t have expensive equipment or medicine. I
                                                    use information, education. I profoundly believe that the
                                                    power of food has a primal place in our homes that binds us
                                                    to the best bits of life.</p>
                                                <div className="uiheading"><p>We have an awful, awful reality
                                                    right now. America, you’re at the top of your game. This is
                                                    one of the most unhealthy countries in the world. Can I
                                                    please just see a raise of hands for how many of you have
                                                    children in this room today? Please put your hands up……
                                                    aunties and uncles as well. Most of you. OK. We, the adults
                                                    of the last four generations, have blessed our children with
                                                    the destiny of a shorter lifespan than their parents. Your
                                                    child will live a life ten years shorter than you because of
                                                    the landscape of food that we’ve built around them.
                                                    Two-thirds of this room, today, in America, are
                                                    statistically overweight or obese. You lot, you’re all
                                                    right, but we’ll get you eventually, don’t worry. (Laughter)
                                                    Right?</p></div>

                                            </div>

                                            <div className="left-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page4')}
                                                    className="button-next-previous-done">&lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page6')}
                                                    className="button-next-previous-done">Next &gt;&gt;</div>
                                            </div>

                                        </div>
                                    </div>
                                </div>

                            </div>
                        </section>


                    </div>
                </div>
            </div>
        </div>;
    ;
    }
    }